export const windowTypeNames = {
  proof_upload_window: 'Proof upload',
  declaration_window: 'Declaration',
};
